import { render, staticRenderFns } from "./link-bar.vue?vue&type=template&id=456629cf"
import script from "./link-bar.vue?vue&type=script&lang=ts"
export * from "./link-bar.vue?vue&type=script&lang=ts"
import style0 from "./link-bar.vue?vue&type=style&index=0&id=456629cf&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456629cf')) {
      api.createRecord('456629cf', component.options)
    } else {
      api.reload('456629cf', component.options)
    }
    module.hot.accept("./link-bar.vue?vue&type=template&id=456629cf", function () {
      api.rerender('456629cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/link-bar/link-bar.vue"
export default component.exports